<app-table
  [data]="data"
  [columns]="headers"
  [mainField]="mainField"
  [title]="'users.list.title' | transloco"
  [rows]="limit"
  [totalRecords]="totalRecords"
  [loadError]="loadError"
  (retryLoad)="loadUsers()"
  [isLoading]="isLoading"
  (onPageChange)="onPageChange($event)"
  (onSort)="onSort($event)"
  [showActionButton]="true"
  [actionButtonLabel]="'users.list.createButton' | transloco"
  [crudComponent]="userCrud"
  (actionButtonClick)="userCrud.show()"
  [getMenuActions]="getMenuActions.bind(this)"
  (menuActionTriggered)="menuActionTriggered($event)"
  (rowSelected)="onRowSelected($event)"
  [pillFilters]="pillFilters"
  [pillFiltersLoading]="filtersLoading ? 2 : 0"
  [pillFilterValues]="currentFilters"
  (inlineFilterChange)="onInlineFilterChange($event)"
  [showSearch]="true"
  (searchEvent)="onInlineFilterChange({ key: 'search', value: $event })"
></app-table>

<!-- 📌 User CRUD Modal -->
<app-user-crud
  #userCrud
  (userUpdated)="onUserUpdated()"
></app-user-crud>

<!-- 📌 User Detail Modal -->
<app-user-detail
  #userDetail
  (editRequested)="onEditFromDetail($event)"
  (blockRequested)="onBlockFromDetail($event)"
  (unbanRequested)="onUnbanFromDetail($event)"
  (deletePermanentlyRequested)="onDeletePermanentlyFromDetail($event)"
></app-user-detail>
